// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"699":"edcceca2","8880":"31647bf8"}[chunkId] + ".chunk.css";
};